import React from 'react'
import { Button } from 'antd'
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle,
  AlignmentType,
} from 'docx'
import { saveAs } from 'file-saver'
import { result } from 'lodash'

const ExportDocx = ({
  feedbackDetailData,
  finalUserList,
  countAllUser,
  countAgree,
  countDisAgree,
  countOther,
  totalPeopleCount,
  resultsVoting,
}) => {
  const {
    id,
    title,
    content,
    startDate,
    assignees,
    endDate,
    legalBasis,
    attachedDocuments,
    otherContent,
    feedbackComments,
  } = feedbackDetailData

  assignees?.forEach(el => {
    const user =
      finalUserList &&
      finalUserList?.find(user => user.username === el.assignee_code)
    if (user) {
      el.name_uppercase = user.name_uppercase
      el.position = user.position.name
    }
  })
  resultsVoting?.forEach(comment => {
    comment?.forEach(detail => {
      const user = finalUserList?.find(
        user => user.username === detail.feedbackUsername
      )
      if (user) {
        detail.name_uppercase = user.name_uppercase
        detail.position = user.position?.name
      }
    })
  })

  let results = resultsVoting?.map(feedbackList => {
    let countAgree = 0
    let countDisAgree = 0
    let countOther = 0

    feedbackList?.forEach(feedback => {
      switch (feedback.voteType) {
        case 'AGREE':
          countAgree++
          break
        case 'DISAGREE':
          countDisAgree++
          break
        default:
          countOther++
          break
      }
    })

    return {
      content: feedbackList?.[0]?.content,
      countAgree,
      countDisAgree,
      countOther,
    }
  })

  const htmlToTextContent = htmlContent => {
    const div = document.createElement('div')
    div.innerHTML = htmlContent

    const paragraphs = []

    div.childNodes.forEach(node => {
      // Handle paragraphs
      if (node.nodeName === 'P') {
        let paragraphText = ''

        // Handle child nodes like spans and strong/italic tags inside <p> tags
        node.childNodes.forEach(childNode => {
          if (childNode.nodeName === '#text') {
            paragraphText += childNode.textContent
          } else if (
            childNode.nodeName === 'SPAN' ||
            childNode.nodeName === 'STRONG' ||
            childNode.nodeName === 'EM'
          ) {
            paragraphText += childNode.textContent
          }
        })

        if (paragraphText.trim()) {
          paragraphs.push(paragraphText)
        }
      }

      // Handle unordered lists
      if (node.nodeName === 'UL') {
        node.childNodes.forEach(listItem => {
          if (listItem.nodeName === 'LI') {
            let listItemText = ''
            listItem.childNodes.forEach(childNode => {
              if (
                childNode.nodeName === '#text' ||
                childNode.nodeName === 'SPAN' ||
                childNode.nodeName === 'STRONG' ||
                childNode.nodeName === 'EM'
              ) {
                listItemText += childNode.textContent
              }
            })
            if (listItemText.trim()) {
              paragraphs.push(`- ${listItemText}`)
            }
          }
        })
      }

      // Handle ordered lists
      if (node.nodeName === 'OL') {
        node.childNodes.forEach(listItem => {
          if (listItem.nodeName === 'LI') {
            let listItemText = ''
            listItem.childNodes.forEach(childNode => {
              if (
                childNode.nodeName === '#text' ||
                childNode.nodeName === 'SPAN' ||
                childNode.nodeName === 'STRONG' ||
                childNode.nodeName === 'EM'
              ) {
                listItemText += childNode.textContent
              }
            })
            if (listItemText.trim()) {
              paragraphs.push(`1. ${listItemText}`)
            }
          }
        })
      }
    })
    return paragraphs // Array of text paragraphs
  }

  function htmlToText(html) {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }
  function formatNumber(num) {
    // Chuyển đổi số thành chuỗi và kiểm tra độ dài
    return num < 10 ? `0${num}` : `${num}`
  }

  const capitalizeFirstLetter = str => {
    return str
      .toLowerCase() // Convert the whole string to lower case first
      .split(' ') // Split by spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' ') // Join back to a single string
  }

  const percentAgree =
    countAllUser > 0
      ? ((countAgree / countAllUser) * 100).toFixed(2) + '%'
      : '0%'
  const percentDisAgree =
    countAllUser > 0
      ? ((countDisAgree / countAllUser) * 100).toFixed(2) + '%'
      : '0%'
  const percentOther =
    countAllUser > 0
      ? ((countOther / countAllUser) * 100).toFixed(2) + '%'
      : '0%'
  // Tạo mảng dữ liệu mới với các giá trị đếm
  const data = [
    ['TT', 'Nội dung', 'Số lượng ủy', 'Tỷ lệ chiếm', 'Ghi chú'], // Header
    [
      '1',
      'Ý kiến đồng ý',
      `${formatNumber(result.countAgree)}`,
      `${((result.countAgree / totalPeopleCount) * 100).toFixed(2)}%`,
      '',
    ],
    [
      '2',
      'Ý kiến không đồng ý',
      `${formatNumber(result.countDisAgree)}`,
      `${((result.countDisAgree / totalPeopleCount) * 100).toFixed(2)}%`,
      '',
    ],
    [
      '3',
      'Không có ý kiến/ Ý kiến khác',
      `${formatNumber(result.countOther)}`,
      `${((result.countOther / totalPeopleCount) * 100).toFixed(2)}%}`,
      '',
    ],
  ]
  const createTableFromRecords = (record, index) => {
    const agreePercentage =
      totalPeopleCount === 0
        ? '0%'
        : ((record.countAgree / totalPeopleCount) * 100).toFixed(2) + '%'
    const disagreePercentage =
      totalPeopleCount === 0
        ? '0%'
        : ((record.countDisAgree / totalPeopleCount) * 100).toFixed(2) + '%'
    const otherPercentage =
      totalPeopleCount === 0
        ? '0%'
        : ((record.countOther / totalPeopleCount) * 100).toFixed(2) + '%'
    const noOpinionCount =
      totalPeopleCount -
      (record.countAgree + record.countDisAgree + record.countOther)
    const noOpinionPercentage =
      totalPeopleCount === 0
        ? '0%'
        : ((noOpinionCount / totalPeopleCount) * 100).toFixed(2) + '%'
    const cellOptions = {
      margins: { top: 200, bottom: 200, left: 200, right: 200 }, // Add padding inside each cell
    }
    const contentParagraph = new Paragraph({
      children: [
        new TextRun({
          text: record.content, // Content text
          size: 26, // 13pt
        }),
      ],
      alignment: AlignmentType.CENTER, // Center the text
      spacing: { before: 240 }, // Add space before the paragraph (adjust as necessary)
    })
    return new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [
        // Header row with increased font size and bold text
        new TableRow({
          children: [
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'TT',
                      bold: true,
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Nội dung',
                      bold: true,
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Số lượng ủy',
                      bold: true,
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Tỷ lệ chiếm',
                      bold: true,
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Ghi chú',
                      bold: true,
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          ],
        }),
        // "Đồng ý" row
        new TableRow({
          ...cellOptions,
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '1', // Row number
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Ý kiến đồng ý', // Nội dung
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: record.countAgree.toString(), // Số lượng ủy for Đồng ý
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: agreePercentage, // Tỷ lệ chiếm for Đồng ý
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '', // Empty Ghi chú
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          ],
        }),
        // "Không đồng ý" row
        new TableRow({
          ...cellOptions,
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '2',
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Ý kiến không đồng ý', // Nội dung
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: record.countDisAgree.toString(), // Số lượng ủy for Không đồng ý
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: disagreePercentage, // Tỷ lệ chiếm for Không đồng ý
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '', // Empty Ghi chú
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          ],
        }),
        // "Ý kiến khác" row
        new TableRow({
          children: [
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '3',
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Không có ý kiến/ Ý kiến khác', // Nội dung
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: record.countOther.toString(), // Số lượng ủy for Ý kiến khác
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: otherPercentage, // Tỷ lệ chiếm for Ý kiến khác
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '', // Empty Ghi chú
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          ],
        }),
        // "Không có ý kiến" row
        new TableRow({
          children: [
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '4',
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: 'Không có ý kiến', // Nội dung
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.LEFT,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: noOpinionCount.toString(), // Số lượng ủy for Không có ý kiến
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: noOpinionPercentage, // Tỷ lệ chiếm for Không có ý kiến
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
            new TableCell({
              ...cellOptions,
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: '', // Empty Ghi chú
                      size: 26, // 13pt
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          ],
        }),
      ],
    })
  }

  const data1 = [
    ['TT', 'Nội dung', 'Số lượng ủy', 'Tỷ lệ chiếm', 'Ghi chú'], // Header
    ...results.flatMap((result, index) => [
      [
        `${index + 1}`,
        `${formatNumber(result.countAgree)}`,
        `${formatNumber(
          (result.countAgree /
            (result.countAgree + result.countDisAgree + result.countOther)) *
            100
        )}%`, // Tính tỷ lệ chiếm
        '',
      ],
      [
        '',
        'Ý kiến không đồng ý',
        `${formatNumber(result.countDisAgree)}`,
        `${formatNumber(
          (result.countDisAgree /
            (result.countAgree + result.countDisAgree + result.countOther)) *
            100
        )}%`, // Tính tỷ lệ chiếm
        '',
      ],
      [
        '',
        'Không có ý kiến/ Ý kiến khác',
        `${formatNumber(result.countOther)}`,
        `${formatNumber(
          (result.countOther /
            (result.countAgree + result.countDisAgree + result.countOther)) *
            100
        )}%`, // Tính tỷ lệ chiếm
        '',
      ],
    ]),
  ]
  function stripHtmlTags(html) {
    return html.replace(/<\/?[^>]+(>|$)/g, '') // Regular expression to remove HTML tags
  }

  // Function to parse HTML and convert it to docx Paragraphs
  const colorNameToHex = {
    black: '000000',
    red: 'FF0000',
    blue: '0000FF',
    green: '00FF00',
    yellow: 'FFFF00',
    // Add more colors as needed
  }
  // Function to parse HTML and convert it to docx Paragraphs with styles

  const columnWidths = [5, 35, 20, 20, 20]

  const generateDocx = () => {
    const doc = new Document({
      sections: [
        {
          properties: {},
          children: [
            new Table({
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: 'CÔNG TY CỔ PHẦN',
                              bold: true,
                              allCaps: true,
                              size: 26,
                            }),
                            new TextRun({
                              text: 'ĐẠI LÝ HÀNG HẢI VIỆT NAM',
                              bold: true,
                              break: 1,
                              size: 26,
                            }),
                            new TextRun({
                              text: '____________',
                              bold: true,
                              break: 1,
                              size: 26,
                            }),
                          ],
                          alignment: AlignmentType.CENTER, // Horizontal center
                        }),
                      ],
                      width: { size: 35, type: WidthType.PERCENTAGE },
                      borders: {
                        top: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        bottom: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        left: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        right: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                      },
                      verticalAlign: 'center', // Vertical center
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: 'CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM',
                              bold: true,
                              allCaps: true,
                              size: 26,
                            }),
                            new TextRun({
                              text: 'Độc lập - Tự do - Hạnh phúc',
                              bold: true,
                              size: 26,
                              break: 1,
                            }),
                            new TextRun({
                              text: '____________',
                              bold: true,
                              break: 1,
                              size: 26,
                            }),
                          ],
                          alignment: AlignmentType.CENTER, // Horizontal center
                        }),
                      ],
                      width: { size: 65, type: WidthType.PERCENTAGE },
                      borders: {
                        top: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        bottom: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        left: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        right: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                      },
                      verticalAlign: 'center', // Vertical center
                    }),
                  ],
                }),
              ],
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `TP. Hồ Chí Minh, ngày ${formatNumber(
                    new Date().getDate()
                  )} tháng ${formatNumber(
                    new Date().getMonth() + 1
                  )} năm ${new Date().getFullYear()}`,
                  italics: true,
                  size: 26,
                }),
              ],
              alignment: AlignmentType.RIGHT,
              spacing: {
                before: 300,
              },
              indent: {
                right: 200,
              },
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: 'TỜ TRÌNH TỔNG HỢP Ý KIẾN HỘI ĐỒNG QUẢN TRỊ',
                  bold: true,
                  allCaps: true,
                  size: 28,
                }),
              ],
              alignment: 'center',
              spacing: {
                before: 300,
              },
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: title,
                  bold: true,
                  size: 26,
                }),
                new TextRun({
                  text: '____________________________________',
                  bold: true,
                  size: 26,
                  break: 1,
                }),
              ],
              alignment: 'center',
              spacing: {
                after: 200,
                line: 200,
              },
              indent: {
                left: 800,
                right: 800,
              },
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text:
                    'Kính gửi: Người phụ trách điều hành hoạt động của Hội đồng quản trị, Thành viên Hội đồng quản trị Công ty cổ phần đại lý hàng hải Việt Nam',
                  size: 26,
                }),
              ],
              alignment: 'center',
              spacing: {
                after: 200, // Space after the paragraph (unit: 1/20 point)
                line: 276, // Line spacing (unit: 1/20 point, about 13.8px for 1 line)
              },
              indent: {
                left: 650, // Left indent
                right: 650, // Right indent
              },
            }),
            new Paragraph({
              children: htmlToTextContent(legalBasis).map(
                (item, index) =>
                  new TextRun({
                    text: `          ${item}`,
                    size: 26,
                    break:
                      index <= htmlToTextContent(legalBasis).length ? 1 : 0,
                  })
              ),
              alignment: AlignmentType.JUSTIFIED,
              spacing: {
                after: 200,
                line: 276,
              },
              indent: {
                firstLine: 500,
              },
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: `Sau khi xin ý kiến các thành viên Hội đồng quản trị, đến ngày ${formatNumber(
                    new Date().getDate()
                  )}/${formatNumber(
                    new Date().getMonth() + 1
                  )}/${new Date().getFullYear()}, Người phụ trách quản trị công ty đã nhận được ${
                    results.length
                  } nội dung ý kiến của các thành viên Hội đồng quản trị như sau:`,
                  size: 26, // or fontSize depending on the library
                }),
              ],
              alignment: AlignmentType.JUSTIFIED,
              spacing: {
                after: 100, // Space after the paragraph (in 1/20 points)
                line: 276, // Line spacing (in 1/20 points, approx 13.8px for 1 line)
              },
              indent: {
                firstLine: 500, // Indent the first line specifically
              },
            }),
            new Paragraph({
              spacing: {
                after: 100, // Space after the paragraph (in 1/20 points)
                line: 360, // Line spacing (in 1/20 points, approx 13.8px for 1 line)
              },
              indent: {
                left: 500, // Indent the first line specifically
              },
              children: (() => {
                const displayedUsernames = new Set()

                return feedbackComments.flatMap(comment => {
                  const uniqueDetails = new Map()

                  // Thêm các mục vào Map chỉ nếu feedbackUsername chưa tồn tại trong `displayedUsernames`
                  comment.feedbackCommentDetails.forEach(detail => {
                    if (
                      detail.position &&
                      !displayedUsernames.has(detail.feedbackUsername) &&
                      !uniqueDetails.has(detail.feedbackUsername)
                    ) {
                      uniqueDetails.set(detail.feedbackUsername, detail)
                      displayedUsernames.add(detail.feedbackUsername)
                    }
                  })

                  // Chuyển đổi các mục duy nhất thành TextRun
                  const detailsArray = Array.from(uniqueDetails.values())
                  return detailsArray
                    .map((detail, index) => [
                      new TextRun({
                        text: `- ${capitalizeFirstLetter(
                          detail.name_uppercase
                        )} - ${detail.position}`,
                        size: 26,
                      }),
                      // Chỉ thêm dòng ngắt nếu đây không phải là mục cuối cùng
                      ...(index < detailsArray.length - 1
                        ? [new TextRun({ break: 1 })]
                        : []),
                    ])
                    .flat()
                })
              })(),
            }),
            new Paragraph({
              children: results.flatMap(result => [
                new TextRun({
                  text: `Nội dung: ${htmlToTextContent(result.content)} (${
                    result.countAgree + result.countDisAgree + result.countOther
                  }/${totalPeopleCount})`, // Nội dung phản hồi
                  // bold: true,
                  size: 26,
                  break: 1,
                }),
                new TextRun({
                  text: `1. Ý kiến đồng ý: ${formatNumber(
                    result.countAgree
                  )} thành viên`, // Số ý kiến đồng ý
                  size: 26,
                  bold: true,
                  break: 1,
                }),
                new TextRun({
                  text: `2. Ý kiến không đồng ý: ${formatNumber(
                    result.countDisAgree
                  )} thành viên`, // Số ý kiến không đồng ý
                  size: 26,
                  bold: true,
                  break: 1,
                }),
                new TextRun({
                  text: `3. Không có ý kiến/ Ý kiến khác: ${formatNumber(
                    result.countOther
                  )} thành viên`, // Số ý kiến khác
                  size: 26,
                  bold: true,
                  break: 1,
                }),
                new TextRun({
                  text: `4. Không có ý kiến: ${formatNumber(
                    totalPeopleCount -
                      (result.countAgree +
                        result.countDisAgree +
                        result.countOther)
                  )} thành viên`, // Số ý kiến ko khác
                  size: 26,
                  bold: true,
                  break: 1,
                }),
              ]),
              spacing: {
                after: 100,
                line: 360,
              },
              indent: {
                left: 500,
              },
            }),
            new Paragraph({
              children: [
                new TextRun({
                  text: 'Kết quả cụ thể theo các bảng sau:',
                  size: 26,
                  break: 1,
                }),
              ],
              spacing: {
                after: 100,
                line: 360,
              },
              indent: {
                left: 500,
              },
            }),
            ...results
              ?.map((record, index) => createTableFromRecords(record, index)) // Call the new function for each record
              .reduce((acc, table) => {
                acc.push(table)
                acc.push(new Paragraph({ text: '', spacing: { after: 300 } })) // Add spacing after each table
                return acc
              }, []),

            // new Table({
            //   width: { size: 100, type: WidthType.PERCENTAGE },
            //   rows: data.map(
            //     (row, index) =>
            //       new TableRow({
            //         children: row.map((cell, idx) => {
            //           // Default width for cells
            //           const cellWidth =
            //             index === 0 ? columnWidths[idx] : undefined

            //           return new TableCell({
            //             children: [
            //               new Paragraph({
            //                 text: cell,
            //                 alignment:
            //                   idx === 1 ? undefined : AlignmentType.CENTER,
            //                 spacing: { before: 200, after: 100 },
            //                 font: {
            //                   size: 26, // Kích thước chữ
            //                 },
            //                 ...(idx === 1 && { indent: { left: 360 } }), // Thụt lề cho cột Nội dung
            //                 bold: index === 0, // Đậm cho hàng tiêu đề
            //               }),
            //             ],
            //             ...(cellWidth
            //               ? {
            //                   width: {
            //                     size: cellWidth,
            //                     type: WidthType.PERCENTAGE,
            //                   },
            //                 }
            //               : {}),
            //           })
            //         }),
            //       })
            //   ),
            // }),
            new Paragraph({
              children: [
                new TextRun({
                  text:
                    'Kính trình Người phụ trách điều hành hoạt động của Hội đồng quản trị, Thành viên HĐQT cho ý kiến chấp thuận để Người phụ trách quản trị công ty soạn thảo các văn bản của Hội đồng quản trị về các nội dung trên và trình ký, ban hành theo đúng quy định./.',
                  size: 26, // or fontSize depending on the library
                }),
              ],
              alignment: AlignmentType.JUSTIFIED,
              spacing: {
                before: 200, // Space before the paragraph (in 1/20 points)
                after: 200, // Space after the paragraph (in 1/20 points)
                line: 276, // Line spacing (in 1/20 points, approx 13.8px for 1 line)
              },
              indent: {
                firstLine: 500, // Indent the first line specifically
              },
            }),
            new Table({
              rows: [
                new TableRow({
                  children: [
                    // new TableCell({
                    //   children: [
                    //     new Paragraph({
                    //       children: [
                    //         new TextRun({
                    //           text: '',
                    //           bold: true,
                    //           allCaps: true,
                    //           size: 26,
                    //         }),
                    //         new TextRun({
                    //           text: '',
                    //           bold: true,
                    //           break: 1,
                    //           size: 26,
                    //         }),
                    //       ],
                    //       alignment: AlignmentType.CENTER,
                    //       indent: {
                    //         left: 200,
                    //       },
                    //       spacing: {
                    //         after: 300,
                    //       },
                    //     }),
                    //   ],
                    //   width: { size: 10, type: WidthType.PERCENTAGE },
                    //   borders: {
                    //     top: {
                    //       style: BorderStyle.NONE,
                    //       size: 0,
                    //       color: 'FFFFFF',
                    //     },
                    //     bottom: {
                    //       style: BorderStyle.NONE,
                    //       size: 0,
                    //       color: 'FFFFFF',
                    //     },
                    //     left: {
                    //       style: BorderStyle.NONE,
                    //       size: 0,
                    //       color: 'FFFFFF',
                    //     },
                    //     right: {
                    //       style: BorderStyle.NONE,
                    //       size: 0,
                    //       color: 'FFFFFF',
                    //     },
                    //   },
                    //   verticalAlign: 'center',
                    // }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: 'Ý KIẾN CHẤP THUẬN CỦA',
                              bold: true,
                              allCaps: true,
                              size: 26,
                            }),
                            new TextRun({
                              text: 'THÀNH VIÊN HĐQT',
                              bold: true,
                              break: 1,
                              size: 26,
                            }),
                          ],
                          alignment: AlignmentType.CENTER,
                          indent: {
                            left: 200,
                          },
                          spacing: {
                            after: 300,
                          },
                        }),
                      ],
                      width: { size: 55, type: WidthType.PERCENTAGE },
                      borders: {
                        top: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        bottom: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        left: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        right: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                      },
                      verticalAlign: 'center',
                    }),
                    new TableCell({
                      children: [
                        new Paragraph({
                          children: [
                            new TextRun({
                              text: 'NGƯỜI TRÌNH',
                              bold: true,
                              allCaps: true,
                              size: 26,
                            }),
                          ],
                          alignment: AlignmentType.CENTER,
                          indent: {
                            left: 800,
                          },
                          spacing: {
                            after: 300,
                          },
                        }),
                      ],
                      width: { size: 30, type: WidthType.PERCENTAGE },
                      borders: {
                        top: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        bottom: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        left: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                        right: {
                          style: BorderStyle.NONE,
                          size: 0,
                          color: 'FFFFFF',
                        },
                      },
                      verticalAlign: 'center',
                    }),
                  ],
                }),
              ],
            }),
          ],
        },
      ],
    })

    Packer.toBlob(doc).then(blob => {
      saveAs(blob, `Phiếu_lấy_ý_kiến_${title}.docx`)
    })
  }

  return <div>{generateDocx()}</div>
}

export default ExportDocx
